<template>
    <v-container>
        <v-row 
            align="center"
            justify="center"
            no-gutters
        >
            <v-col>
                <v-card
                    class="mx-auto text-start"
                    outlined
                    
                >
                    <div class="d-flex flex-no-wrap">
                        <!-- <div>
                            <v-avatar
                                class="ma-3"
                                size="125"
                                tile
                            >
                                <v-img :src="companyDetails.logo"></v-img>
                            </v-avatar>
                        </div> -->
                        <div>
                            <v-card-title>
                                <v-col class="ma-0 pa-0">
                                    {{ companyDetails.companyName }}
                                </v-col>
                                <v-col
                                    v-if="addAliasButton"
                                    md=auto
                                    justify=end
                                >
                                    <v-btn
                                        x-small
                                        fab
                                        dark
                                        color="primary"
                                        @click="addAliasHandler"
                                    >
                                        <v-icon dark>
                                            mdi-plus
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-card-title>
                            <v-card-subtitle v-if="formattedMarkets != ''">
                                {{ formattedMarkets }}
                            </v-card-subtitle>
                            <v-row no-gutters v-if="formattedAliases != ''">
                                <v-card-text>
                                    Aliases: {{ formattedAliases }}
                                </v-card-text>
                                <v-divider class="mx-4"/>
                            </v-row>
                            <div v-if="companyDetails.description != '' && companyDetails.description != undefined">
                                <v-card-text>
                                    {{ companyDetails.description }}
                                </v-card-text>
                                <v-divider class="mx-4"/>
                            </div>
                            <!-- <v-card-text>
                                In the news:
                                <v-row 
                                    no-gutters
                                    v-for="i in articleLinks" 
                                    :key="i">
                                    {{i}}
                                </v-row>
                            </v-card-text> -->
                            <v-card-actions>
                                <v-btn
                                    :href=companyRoute
                                    color="accent">
                                    See More Details
                                </v-btn>
                            </v-card-actions>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "company-thumbnail", 
    props: {
        "companyDetails": Object,
        "addAliasButton": Boolean,
    }, 
    data() {
        return {
            "companyId": null,
            "articleLinks": [
                "http://www.google.com",
                "http://www.github.com",
                "http://www.sci-hub.se",
            ]
        }
    },
    computed: {
        companyRoute: function () {
            return "/company/" + this.companyDetails._id
        },
        formattedMarkets: function () {
            if (this.companyDetails.market != undefined && this.companyDetails.market.length > 0) {
                // TODO: add links for industries
                return "#" + this.companyDetails.market.join(" #")
            } else {
                return ""
            }
        },
        formattedAliases: function () {
            if (this.companyDetails.aliases != undefined && this.companyDetails.aliases.length > 0) {
                return this.companyDetails.aliases.join("; ")
            } else {
                return ""
            }
        },
    },
    methods: {
        addAliasHandler() {
            console.log("emit event from thumbnail");
            this.$emit("emitAddAliasEvent", this.companyDetails._id)
        },
    },
}
</script>